import * as React from "react"

import { formatDate } from "@ui-seeker/utils";
import { Box, Typography } from "@mui/material";


export default function startEndDateColumn() {
    return {
        name: 'minDate', label: 'Start/End Date',
        options: {
            filter: false,
            setCellHeaderProps: () => ({
                sx: { minWidth: 150 }
            }),
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => <Box>
                <Typography variant="body2" sx={{fontSize: '0.875rem'}} gutterBottom >
                    {row.numDates} Days
                </Typography>
                <Typography variant="body2" sx={{fontSize: '0.875rem'}} gutterBottom >
                    {formatDate(value, { isString: true })} - {formatDate(row.maxDate, { isString: true })}
                </Typography>

            </Box>
        }
    }
}